import React, { ReactNode } from "react";
import classNames from "classnames";
import { Reaction } from "workstep/pages/Feedback/Comments/state/types";

import { Caption, Body2 } from "./Text";
import ReactionBadge from "./ReactionBadge";

type Props = {
    from: string | null;
    time: string;
    message: ReactNode;
    side: "left" | "right";
    className?: string;
    reaction: Maybe<Reaction>;
    onReactionChange?: ((value: Maybe<Reaction>) => void) | undefined;
    reactionLoading?: boolean;
};

const ConversationBubble = ({
    from,
    time,
    message,
    side,
    className,
    reaction,
    onReactionChange,
    reactionLoading = false,
}: Props) => (
    <div
        className={classNames(
            "ws-conversation-bubble mt-sm prel",
            `ws-conversation-bubble--${side}`,
            className,
            {
                "ws-conversation-bubble--blue": side === "right",
            },
        )}
    >
        <div
            className={classNames("flex", {
                "flex-jfe": side === "right",
            })}
        >
            <Caption className="color-navy-medium fw-medium mt-sm flex flex-row gap-sm">
                <span>{from}</span>
                <span>{time}</span>
            </Caption>
        </div>
        <div className="ws-conversation-bubble__message__container">
            <Body2 className="ws-conversation-bubble__message">{message}</Body2>
            <ReactionBadge
                side={side}
                reaction={reaction}
                onChange={onReactionChange}
                isLoading={reactionLoading}
            />
        </div>
    </div>
);

export default ConversationBubble;
